import React from 'react';
import HomeHero from './HomeHero';

const HeroComponent = () => {
  return <HomeHero />;
};

export default HeroComponent;
